/* eslint-disable no-undef */
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 
  (process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://astrocharts-backend-jvttoo2p7a-uc.a.run.app');
/* eslint-enable no-undef */
